import * as React from "react"

import Link from "../Link"

interface Props {
    attributes: Record<string, string>
    label: string
}

export const CreateWorkspace = ({ attributes, label }: Props): JSX.Element => {
    const href = "dashboard/createnewworkspace"
    return <Link attributes={attributes} label={label} href={href} />
}

export default CreateWorkspace
